import React from "react";
import { Box } from "@mui/material";

// Components
import { GenerateSuppliersForm } from "../../@components/GenerateSuppliersForm/GenerateSuppliersForm";

export function GenerateSuppliers() {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <GenerateSuppliersForm />
    </Box>
  );
}
